import React from 'react';
import InvoiceStatusState from '../../enums/InvoiceStatusState';

interface InvoiceStatusBadgeProps {
  state: InvoiceStatusState;
  label?: string;
  fontSize?: string;
}

export default function InvoiceStatusBadge({
  state,
  label = undefined,
  fontSize = '0.75rem',
}: InvoiceStatusBadgeProps) {
  const badgeParams: any = {
    [InvoiceStatusState.Draft]: {
      title: 'Rascunho',
      class: 'badge-outline',
    },
    [InvoiceStatusState.Todo]: {
      title: 'Não Iniciado',
      class: 'bg-primary',
    },
    [InvoiceStatusState.Wip]: {
      title: 'Em Andamento',
      class: 'bg-primary',
    },
    [InvoiceStatusState.Blocked]: {
      title: 'Bloqueado',
      class: 'bg-warning text-black',
    },
    [InvoiceStatusState.Canceled]: {
      title: 'Cancelado',
      class: 'bg-dark',
    },
    [InvoiceStatusState.Completed]: {
      title: 'Concluído',
      class: 'badge-outline success',
    },
  };

  return (
    <span
      className={`badge ${badgeParams[state].class} text-uppercase`}
      style={{ fontSize }}
      title={label}
    >
      {badgeParams[state].title}
    </span>
  );
}
